<template>
  <div>
    <el-form size="small" label-width="100px" class="margin15-tb" v-show="ruleSearchShow">
      <el-row :gutter="24">
        <el-col :span="6">
          <el-form-item label="标签">
            <el-select v-model="labelSelected" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in labelOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="模板名称">
            <el-input v-model="templateName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <div class="text left">
            <el-button type="primary" size="mini" @click="search">搜索</el-button>
            <el-button size="mini" @click="reset">重置</el-button>
            <el-button size="mini" type="text" @click="deploy(true)">展开<el-icon class="el-icon-arrow-down"></el-icon></el-button>
          </div>
        </el-col>

      </el-row>
    </el-form>
    <el-form size="small" label-width="100px" class="margin15-tb" v-show="!ruleSearchShow">
      <!-- 第一行 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="标签">
            <el-select v-model="labelSelected" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in labelOption"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="回复对象">
            <el-select v-model="replayObject" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in replayObjectOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="电话状态">
            <el-select v-model="mobileStatus" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in mobileStatusOption"
                :key="item.modelCode"
                :label="item.modelName"
                :value="item.modelCode">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 第二行 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="发送对象">
            <el-select v-model="collectSendObject" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in collectSendObjectOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="类型">
            <el-select v-model="type" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in typeOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="模板名称">
            <el-input v-model="templateName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 第三行 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="时间条件">
            <el-select v-model="startDay" placeholder="请选择" style="width: 50%;">
              <el-option :key="1" :value="1" label="首日"></el-option>
              <el-option
                v-for="(item,index) in 30"
                :key="item"
                :label="'第' + item + '天'"
                v-if="index>0"
                :value="item">
              </el-option>
            </el-select>&#12288;
            <el-input v-model="startNoResponseTime" style="width: 40%; float: right;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="至">
            <el-select v-model="endDay" placeholder="请选择" style="width: 50%;">
              <el-option :key="1" :value="1" label="首日"></el-option>
              <el-option
                v-for="(item,index) in 30"
                :key="item"
                :label="'第' + item + '天'"
                v-if="index>0"
                :value="item">
              </el-option>
            </el-select>&#12288;
            <el-input v-model="endNoResponseTime" style="width: 40%; float: right;"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="模板内容">
            <el-input v-model="templateContent" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 第四行 -->
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item label="限制条件">
            <el-select v-model="limitConditions" placeholder="请选择" style="width: 100%;" multiple filterable collapse-tags>
              <el-option
                v-for="item in limitConditionsOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="策略状态">
            <el-select v-model="enable" placeholder="请选择" style="width: 100%;" clearable>
              <el-option
                v-for="item in enableOption"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" :offset="8">
          <div class="text right">
            <el-button type="primary" size="mini" @click="search">搜索</el-button>
            <el-button size="mini" @click="reset">重置</el-button>
            <el-button size="mini" type="text" @click="deploy(false)">收缩<el-icon class="el-icon-arrow-up"></el-icon></el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <p>
      <el-button type="primary" icon="el-icon-plus" size="small" @click="addParam"  v-if="this.$hasPerm('B009')">添加策略</el-button>
      <el-button type="success" size="mini" @click="exportExcel">导出Excel</el-button>
      <el-button type="primary" size="mini" @click="batchUpdateStrategyStatus(true)" :disabled="selectedRows.length === 0" style="margin-left: 10px;">批量开启</el-button>
      <el-button type="warning" size="mini" @click="batchUpdateStrategyStatus(false)" :disabled="selectedRows.length === 0">批量关闭</el-button>
    </p>

    <div class="padding15-tb">
      <el-table id="table1" ref="strategyTable"
        :data="strategyList"
        v-loading="loading"
        size="small"
        :span-method="arraySpanMethod"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="labelName"
          label="标签"
          align="center"
          width="180">
        </el-table-column>
        <el-table-column
          prop="contactType"
          align="center"
          label="回复对象">
        </el-table-column>
        <el-table-column
          prop="mobileStatus"
          align="center"
          label="电话状态">
        </el-table-column>
        <el-table-column
          prop="collectSendObjectName"
          align="center"
          label="发送对象">
        </el-table-column>
        <el-table-column
          prop="noResponseTime"
          :formatter="noResponseTimeFormatter"
          align="center"
          label="时间条件">
        </el-table-column>
        <el-table-column
          prop="limitConditionName"
          align="center"
          label="限制条件">
        </el-table-column>
        <el-table-column
          prop="typeName"
          align="center"
          label="类型">
        </el-table-column>
        <el-table-column
          prop="templateName"
          align="center"
          width="200px"
          label="模板名称">
          <template slot-scope="scope">
            <el-tooltip placement="top" effect="light">
              <!-- <div slot="content">{{scope.row.content}}</div> -->
              <div slot="content" v-html="scope.row.content"></div>
              <span>{{scope.row.templateName}}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="msgChannelName"
          align="center"
          label="通道">
        </el-table-column>
        <el-table-column
          prop="isSend"
          align="center"
          label="是否发送">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isSend === true">默认发送</el-tag>
            <el-tag v-else type="danger">策略不发送</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="isFollow"
          align="center"
          v-if="this.$partB()"
          label="跟进策略">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.isFollow === true">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="noLimitStrategy"
          align="center"
          label="解除上限控制">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.noLimitStrategy === true">是</el-tag>
            <el-tag v-else type="danger">否</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="180px"
          v-if="this.$hasPerm('B009')">
          <template slot-scope="scope">
            <el-button type="text" size="medium" icon="el-icon-plus" @click="addStrategyOperParam(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-edit-outline" @click="updateStrategyOperParam(scope.row)"></el-button>
            <el-button type="text" size="medium" icon="el-icon-delete" @click="deleteStrategyOper(scope.row)"></el-button>
            &nbsp;
            <el-switch
              v-model="scope.row.enable" @change="openOrCloseStrategyOper(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
      <div class="text center margin15-tb">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageData.currentPage"
          :page-sizes="[50, 100, 200]"
          :page-size="pageData.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pageData.totalCount">
        </el-pagination>
      </div>
    </div>

    <div class="dialog">
      <!-- 添加策略 -->
      <el-dialog
        :title="strategyDialogTitle"
        :visible.sync="addStrategyVisible"
        center
        width="70%">
        <div>
          <el-form
          size="small"
          label-width="140px">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="发送模式">
                  <el-select v-model="addStrategyType" style="width: 100%;" placeholder="请选择" filterable @change="addStrategyTypeChange">
                    <el-option
                      v-for="item in typeOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="模板名称">
                  <el-select v-model="addStrategyTemplateIndex" style="width: 100%;" placeholder="请选择" filterable>
                    <el-option
                      v-for="(item, index) in templateOption"
                      :key="item.id"
                      :label="item.name"
                      :value="index"
                      :title="item.name">
                      <el-tooltip effect="light" placement="top">
                        <div slot="content" v-html="item.content || item.templateContent || item.template || item.name"></div>
                        <span>{{ item.name }}</span>
                      </el-tooltip>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="匹配标签">
                  <el-select :key="labelSelectKey" v-model="addStrategyLabelIndex" style="width: 100%;" placeholder="请选择" filterable :multiple="!isEdit" collapse-tags @change="addStrategyLabelChange">
                    <el-option
                      v-for="(item, index) in labelOption"
                      :key="item.id"
                      :label="item.name"
                      :value="index">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="电话状态">
                  <el-select v-model="addStrategyPhone" style="width: 100%;" placeholder="请选择" filterable multiple collapse-tags>
                    <!-- <el-option value="" label="未选择"></el-option> -->
                    <el-option
                      v-for="item in mobileStatusOption"
                      :key="item.modelCode"
                      :label="item.modelName"
                      :value="item.modelCode">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="回复对象">
                  <el-select v-model="addStrategyReplay" style="width: 100%;" placeholder="请选择" filterable>
                    <el-option
                      v-for="item in replayObjectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                label="发送对象">
                  <el-select v-model="addStrategySend" style="width: 100%;" placeholder="请选择" filterable multiple collapse-tags>
                    <el-option
                      v-for="item in collectSendObjectOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="时间条件">
                  <el-select v-model="addStrategyTimeCondition" style="width: 100%;" placeholder="请选择" filterable @change="addStrategyTimeConditionChange">
                    <el-option
                      v-for="item in timeConditionOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="10" v-show="addStrategyTimeVisible">
                <el-select v-model="addDay" placeholder="请选择" style="width: 100px; margin-left:70px;" @change="addDayChange">
                  <el-option :key="1" :value="1" label="首日"></el-option>
                  <el-option
                    v-for="(item,index) in 30"
                    :key="item"
                    :label="'第' + item + '天'"
                    v-if="index>0"
                    :value="item">
                  </el-option>
                </el-select>
                <el-input type="number" v-model="addNoResponseTime" :placeholder="addNoResponseTimePlaceholder" @keydown="handleInput" style="width: 150px;"/>&nbsp;
                <span>小时后</span>
              </el-col>
              <el-col :span="10" v-show="!addStrategyTimeVisible">
                <el-input type="number" v-model="addNoResponseTime" :placeholder="addPromiseTimePlaceholder" @keydown="handleInput" style="width: 250px; margin-left:70px;"/>&nbsp;
                <span>小时</span>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="通道">
                  <el-select v-model="addStrategyChannel" style="width: 100%;" placeholder="请选择" filterable>
                    <el-option
                      v-for="item in channelOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="立即生效">
                  <el-switch v-model="addStrategyActive" style="width: 15%;"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item label="限制条件">
                  <el-select v-model="addStrategyLimitCondition" style="width: 100%;" placeholder="请选择" filterable>
                    <el-option
                      v-for="item in limitConditionsOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="策略是否发送">
                  <el-switch v-model="isSend" style="width: 15%;"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="24" style="margin-top: 10px;">
              <el-col :span="12">
                <el-form-item label="跟进策略">
                  <el-switch v-model="isFollow" style="width: 15%;"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="解除上限控制">
                  <el-switch v-model="noLimitStrategy" style="width: 15%;"/>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="updateOrInsertStrategyCancel" size="small">取 消</el-button>
          <el-button type="primary" @click="updateOrInsertStrategySave" size="small">保存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    labelOption: {
      type: Array
    },
    templateMsgOption: {
      type: Array
    },
    templateVoiceOption: {
      type: Array
    },
    templateIVoiceOption: {
      type: Array
    },
    templateSVoiceOption: {
      type: Array
    },
    changeTabe: {
      type: String
    },
    companySelected: {
    },
    groupSelected: {
    }
  },
  watch: {
    changeTabe(type) {
      if (type === '策略明细') {
        if (this.companyId !== '') {
          this.initTemplateList();
          this.getSengRuleData(1);
        }
      }
    },
    companySelected(companyId) {
      this.companyId = companyId;
    },
    groupSelected(groupId) {
      this.groupId = groupId;
      if (this.changeTabe === '策略明细') {
        this.initTemplateList();
        this.getSengRuleData(1);
      }
    }
  },
  data() {
    return {
      loading: true,
      companyId: '',
      groupId: '',
      pageData: {},
      startTime: '',
      list: [],
      labelSelected: [],
      templateName: null,
      templateContent: null,
      startNoResponseTime: '',
      startDay: 1,
      endNoResponseTime: '',
      endDay: 2,
      replayObject: [],
      replayObjectOption: [
        {
          value: 'benrendianhua',
          label: '本人电话'
        },
        {
          value: 'zhixidianhua',
          label: '直系电话'
        },
        {
          value: 'feizhixidianhua',
          label: '非直系电话'
        }
      ],
      mobileStatus: [],
      mobileStatusOption: [],
      collectSendObject: [],
      collectSendObjectOption: [
        {
          value: '0',
          label: '当前联系人'
        },
        {
          value: '1',
          label: '本人'
        },
        {
          value: '2',
          label: '直系'
        },
        {
          value: '3',
          label: '非直系'
        },
        {
          value: '4',
          label: '失联修复'
        }
      ],
      type: [],
      typeOption: [
        {
          value: 'msg',
          label: '短信'
        },
        {
          value: 'ivr',
          label: '语音'
        },
        {
          value: 'iVoice',
          label: '智能语音'
        },
        {
          value: 'svoice',
          label: '场景语音'
        }
      ],
      limitConditions: [],
      limitConditionsOption: [
        {
          value: 'NONE',
          label: '无'
        },
        {
          value: 'REDUCE_Y',
          label: '同意减免'
        },
        {
          value: 'REDUCE_N',
          label: '不同意减免'
        },
        {
          value: 'REPAYMENT_DATE_Y',
          label: '同意还款时间'
        },
        {
          value: 'REPAYMENT_DATE_N',
          label: '不同意还款时间'
        }
      ],
      enable: '',
      enableOption: [
        {
          value: '1',
          label: '开启'
        },
        {
          value: '0',
          label: '关闭'
        }
      ],
      channelOption: [
        {
          value: '0',
          label: '照比例随机发送'
        },
        {
          value: 'C',
          label: '卡线'
        },
        {
          value: 'N',
          label: '通知短信'
        },
        {
          value: 'I',
          label: '交互短信'
        }
      ],
      msgChannelOptions: [
        {
          value: '0',
          label: '照比例随机发送'
        },
        {
          value: 'C',
          label: '卡线'
        },
        {
          value: 'N',
          label: '通知短信'
        },
        {
          value: 'I',
          label: '交互短信'
        }
      ],
      ivrChannelOptions: [
        {
          value: '0',
          label: '洗号或ivr照比例随机发送'
        },
        {
          value: 'washNum',
          label: '洗号'
        },
        {
          value: 'ivrCall',
          label: 'ivr'
        }
      ],
      ivoiceChannelOptions: [
        {
          value: 'voice',
          label: '交互语音'
        }
      ],
      svoiceChannelOptions: [
        {
          value: 'sceneRobot',
          label: '场景语音-机器'
        },
        {
          value: 'scenePerson',
          label: '场景语音-声优'
        }
      ],
      timeConditionOption: [],
      timeConditionOneOption: [
        {
          value: 0,
          label: '无回应时间'
        }
      ],
      timeConditionTwoOption: [
        {
          value: 0,
          label: '无回应时间'
        },
        {
          value: 1,
          label: '承诺还款时间'
        }
      ],
      addLabelLabel: '',
      labelTypePomiseRepay: '有还款意向及时间',
      timeTypePomiseRepay: 1,
      templateType: {
        tempTypeMsg: 'msg',
        tempTypeVoice: 'ivr',
        tempTypeIVoice: 'iVoice',
        tempTypeSVoice: 'svoice'
      },
      templateOption: [],
      addStrategyTemplateIndex: '',
      addStrategyTemplateSelected: '',
      addStrategyType: '',
      addStrategyLabelIndex: [],
      addStrategyLabelSelected: [],
      addStrategyPhone: [],
      addStrategyReplay: '',
      addStrategySend: [],
      addStrategyTimeCondition: '',
      addStrategyChannel: '',
      addStrategyActive: '',
      addStrategyLimitCondition: '',
      isSend: true,
      isFollow: false,
      noLimitStrategy: false,
      addDay: '',
      addNoResponseTime: '',
      addStrategyVisible: false,
      ruleSearchShow: true,
      addStrategyTimeVisible: true,
      isEdit: false,
      labelSelectKey: 0,
      spanArr: '',
      onepos: 0,
      towpos: 0,
      strategyList: [],
      strategyDialogTitle: '',
      addStrategySubmit: true,
      addNoResponseTimePlaceholder: '小时数值为8~24',
      addPromiseTimePlaceholder: '承诺还款时间的小时数值为-168~168',
      strategyPoint: 8,
      minNoResponseTime: 0,
      openOrCloseStrategyOperReq: {
        id: '',
        enable: ''
      },
      updateStrategyId: '',
      enableShow: '开启',
      fileList: [],
      selectedRows: []
    };
  },
  mounted() {
  },
  methods: {
    handleSelectionChange(val) {
      this.selectedRows = val || [];
    },
    batchUpdateStrategyStatus(enable) {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message({ type: 'warning', message: '请先选择需要操作的策略' });
        return;
      }
      const actionText = enable ? '批量开启' : '批量关闭';
      this.$confirm(`确定${actionText}选中的策略吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const strategyIds = this.selectedRows.map(item => item.id);
        const strategyToLabelMap = this.selectedRows.reduce((map, item) => {
          map[item.id] = item.labelId;
          return map;
        }, {});
        const req = {
          strategyIds,
          enable,
          strategyToLabelMap
        };
        this.$ajax({
          url: '/strategy/batchUpdateStrategyStatus',
          prompt: true,
          method: 'POST',
          data: req
        }).then(() => {
          this.$message({ type: 'success', message: '批量操作成功' });
          this.getSengRuleData(this.pageData.currentPage || 1);
          if (this.$refs.strategyTable) this.$refs.strategyTable.clearSelection();
        });
      }).catch(() => {
        this.$message({ type: 'info', message: '已取消操作' });
      });
    },
    initTemplateList() {
      const reqMsg = {};
      reqMsg.groupId = this.groupId;
      reqMsg.companyId = this.companyId;
      reqMsg.type = this.templateType.tempTypeMsg;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqMsg
      }).then((res) => {
        this.templateMsgOption = res.data;
      });
      const reqVoice = {};
      reqVoice.companyId = this.companyId;
      reqVoice.groupId = this.groupId;
      reqVoice.type = this.templateType.tempTypeVoice;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqVoice
      }).then((res) => {
        this.templateVoiceOption = res.data;
      });
      const reqIVoice = {};
      reqIVoice.companyId = this.companyId;
      reqIVoice.groupId = this.groupId;
      reqIVoice.type = this.templateType.tempTypeIVoice;
      this.$ajax({
        url: '/template/getTemplatesParam',
        method: 'POST',
        data: reqIVoice
      }).then((res) => {
        this.templateIVoiceOption = res.data;
      });
    },
    getSpanArr(data) {
      this.spanArr = [];
      for (let i = 0; i < data.length; i++) {
        if (i === 0) {
          this.spanArr.push([1, 1]);
          this.onepos = 0;
          this.towpos = 0;
        } else if (data[i].labelName === data[i - 1].labelName) { // 判断当前元素与上一个元素是否相同
          this.spanArr[this.onepos][0] += 1;
          if (data[i].contactType === data[i - 1].contactType) {
            // 上一条
            this.spanArr[this.towpos][1] += 1;
            // 这条
            this.spanArr.push([0, 0]);
          } else {
            this.spanArr.push([0, 1]);
            this.towpos = i;
          }
        } else {
          this.spanArr.push([1, 1]);
          this.onepos = i;
          this.towpos = i;
        }
      }
    },
    arraySpanMethod({ rowIndex, columnIndex }) {
      // 增加选择列后，"标签"对应 spanArr[..., 0]，"回复对象"对应 spanArr[..., 1]
      if (columnIndex === 1) {
        const rows = this.spanArr[rowIndex][0];
        const cols = rows > 0 ? 1 : 0;
        return { rowspan: rows, colspan: cols };
      }
      if (columnIndex === 2) {
        const rows = this.spanArr[rowIndex][1];
        const cols = rows > 0 ? 1 : 0;
        return { rowspan: rows, colspan: cols };
      }
      return { rowspan: 1, colspan: 1 };
    },
    deploy(dp) {
      this.ruleSearchShow = !dp;
    },
    getSengRuleData(page) {
      this.loading = true;
      this.$ajax({
        url: '/strategy/getStrategyList',
        method: 'POST',
        data: this.getSearchParam(page)
      }).then((res) => {
        const self = this;
        self.strategyList = res.data.list;
        this.getSpanArr(self.strategyList);
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
        this.loading = false;
      });
    },
    getSearchParam(page) {
      const req = {
        'companyId': this.companyId,
        'groupId': this.groupId,
        'labelId': this.labelSelected,
        'templateName': this.templateName,
        'templateContent': this.templateContent,
        'contactTypeCode': this.replayObject,
        'mobileStatus': this.mobileStatus,
        'collectSendObject': this.collectSendObject,
        'limitConditions': this.limitConditions,
        'type': this.type,
        'noResponseTime': this.startNoResponseTime ? (this.startNoResponseTime * 60) : null,
        'days': this.startNoResponseTime ? this.startDay : null,
        'noResponseTimes': this.endNoResponseTime ? (this.endNoResponseTime * 60) : null,
        'dayss': this.endNoResponseTime ? this.endDay : null,
        'page': page,
        'limit': this.pageData.pageSize || 50,
        'order': 0,
        'sort': 0,
        'enable': this.enable
      };
      return req;
    },
    getData(req) {
      this.$ajax({
        url: '/strategy/getStrategyList',
        method: 'POST',
        data: req
      }).then((res) => {
        const self = this;
        self.strategyList = res.data.list;
        this.getSpanArr(self.strategyList);
        this.pageData.pageSize = res.data.limit;
        this.pageData.totalCount = res.data.totalRecords;
        this.pageData.currentPage = res.data.currentPage;
      });
    },
    getSengRuleDataByFirst(companyId, strategyPoint, groupId, page) {
      this.companyId = companyId;
      this.strategyPoint = strategyPoint;
      this.groupId = groupId;
      this.getSengRuleData(page);
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getSengRuleData(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageData.currentPage = val;
      this.getSengRuleData(val);
    },
    noResponseTimeFormatter(row) {
      let data = '';
      let temp = '';
      let result = '';
      if (row.timeConditionType === 0 && row.noResponseTime !== 0) {
        // 时间类型:无回应时间
        data = row.point / 60;
        temp = data.toString();
        if (temp.indexOf('.') > -1) {
          data = data.toFixed(1);
        }
        if (row.days === 1) {
          // 发送X小时后
          result = '发送'.concat(data, '小时后');
        } else {
          // 第X日第X点
          result = '第'.concat(row.days, '天第', data, '点');
        }
        return result;
      }
      data = row.noResponseTime / 60;
      temp = data.toString();
      if (temp.indexOf('.') > -1) {
        data = data.toFixed(1);
      }
      if (row.timeConditionType === 1) {
        if (data >= 0) {
          result = '距离承诺还款时间后'.concat(data, '小时');
        } else {
          result = '距离承诺还款时间前'.concat(-data, '小时');
        }
      } else result = '立即回复';
      return result;
    },
    getMobileStatusOption() {
      this.$ajax({
        method: 'GET',
        url: '/dict/list/washResult'
      }).then((res) => {
        this.mobileStatusOption = res.data;
      });
    },
    search() {
      this.getSengRuleData(1);
    },
    getExcelDemo() {
      this.$download({
        url: '/strategy/excel/exportStrategyDemo',
        method: 'GET',
        name: '策略明细导入示例.xlsx'
      });
    },
    exportExcel() {
      this.$download({
        url: '/strategy/excel/exportStrategy',
        method: 'POST',
        data: this.getSearchParam(1),
        name: '策略明细.xlsx'
      });
    },
    reset() {
      this.resetSearchParam();
    },
    resetSearchParam() {
      this.labelSelected = [];
      this.templateName = '';
      this.templateContent = '';
      this.replayObject = [];
      this.mobileStatus = [];
      this.collectSendObject = [];
      this.type = [];
      this.limitConditions = [];
      this.startNoResponseTime = '';
      this.startDay = 1;
      this.endNoResponseTime = '';
      this.endDay = 2;
      this.enable = '';
    },
    addParam() {
      this.isEdit = false;
      this.labelSelectKey += 1;
      this.strategyDialogTitle = '添加策略';
      this.templateOption = this.templateMsgOption;
      this.addStrategyType = this.templateType.tempTypeMsg;
      this.addStrategyTemplateIndex = 0;
      this.addStrategyTemplateSelected = this.templateOption[this.addStrategyTemplateIndex];
      // 清空上一次的标签选择（不默认选中第一个）
      this.addStrategyLabelIndex = [];
      this.addStrategyLabelSelected = [];
      // 强制清空选择输入框显示
      this.$nextTick(() => {
        this.addStrategyLabelIndex = [];
      });
      // 初始不选标签时，默认按无回应时间可选
      this.timeConditionOption = this.timeConditionOneOption;
      this.updateStrategyId = '';
      this.addStrategyPhone = [];
      this.addStrategyReplay = this.replayObjectOption[0].value;
      this.addStrategySend = [];
      this.addStrategyTimeCondition = this.timeConditionOption[0].value;
      this.addStrategyChannel = this.channelOption[0].value;
      this.addStrategyActive = true;
      this.addStrategyLimitCondition = this.limitConditionsOption[0].value;
      this.isSend = true;
      this.isFollow = false;
      this.noLimitStrategy = false;
      this.addDay = 1;
      this.addNoResponseTime = '';
      this.addStrategyVisible = true;
      this.addStrategyTimeVisible = true;
      this.addNoResponseTimePlaceholder = '小时数值为0~24';
      this.minNoResponseTime = 0;
    },
    addStrategyOperParam(row) {
      this.isEdit = false;
      this.labelSelectKey += 1;
      this.strategyDialogTitle = '添加策略';
      this.addStrategyType = row.type;
      if (this.addStrategyType === this.templateType.tempTypeVoice) {
        this.templateOption = this.templateVoiceOption;
        this.channelOption = this.ivrChannelOptions;
      } else if (this.addStrategyType === this.templateType.tempTypeIVoice) {
        this.templateOption = this.templateIVoiceOption;
        this.channelOption = this.ivoiceChannelOptions;
      } else if (this.addStrategyType === this.templateType.tempTypeSVoice) {
        this.templateOption = this.templateSVoiceOption;
        this.channelOption = this.svoiceChannelOptions;
      } else {
        this.templateOption = this.templateMsgOption;
        this.channelOption = this.msgChannelOptions;
      }
      this.templateOption.forEach((e, index) => {
        if (e.id === row.templateId) {
          this.addStrategyTemplateIndex = index;
          this.addStrategyTemplateSelected = e;
          return false;
        }
        return true;
      });
      this.labelOption.forEach((e, index) => {
        if (e.id === row.labelId) {
          // 新增为多选
          this.addStrategyLabelIndex = [index];
          this.addStrategyLabelSelected = [e];
          return false;
        }
        return true;
      });
      if (this.addStrategyLabelSelected[0] && this.addStrategyLabelSelected[0].name === this.labelTypePomiseRepay) {
        this.timeConditionOption = this.timeConditionTwoOption;
      } else {
        this.timeConditionOption = this.timeConditionOneOption;
      }
      this.updateStrategyId = '';
      this.addStrategyPhone = [];
      if (row.mobileStatus) {
        const mobileStatusList = row.mobileStatus.split(',');
        this.mobileStatusOption.forEach((e) => {
          mobileStatusList.forEach((status) => {
            if (e.modelName === status) {
              this.addStrategyPhone.push(e.modelCode);
            }
          });
        });
      }
      this.addStrategyReplay = row.contactTypeCode;
      this.addStrategySend = row.collectSendObject.split('&');
      this.addStrategyTimeCondition = this.timeConditionOption[0].value;
      this.addStrategyChannel = row.msgChannel;
      this.addStrategyActive = row.enable;
      this.addStrategyLimitCondition = row.limitCondition;
      this.isSend = row.isSend;
      this.isFollow = row.isFollow;
      this.noLimitStrategy = !!row.noLimitStrategy;

      this.addDay = row.days;
      this.addDayChange(this.addDay);
      if (this.addStrategyTimeCondition === this.timeTypePomiseRepay) this.addNoResponseTime = row.noResponseTime / 60;
      else this.addNoResponseTime = row.point / 60;
      this.addStrategyVisible = true;

      // this.addDay = 1;
      // this.addNoResponseTime = '';
      // this.addStrategyVisible = true;
      // this.addStrategyTimeVisible = true;
      // this.addNoResponseTimePlaceholder = '小时数值为0~24';
      // this.minNoResponseTime = 0;
    },
    updateStrategyOperParam(row) {
      this.isEdit = true;
      this.labelSelectKey += 1;
      this.strategyDialogTitle = '编辑策略';
      this.updateStrategyId = row.id;
      this.addStrategyType = row.type;
      if (this.addStrategyType === this.templateType.tempTypeVoice) {
        this.templateOption = this.templateVoiceOption;
        this.channelOption = this.ivrChannelOptions;
      } else if (this.addStrategyType === this.templateType.tempTypeIVoice) {
        this.templateOption = this.templateIVoiceOption;
        this.channelOption = this.ivoiceChannelOptions;
      } else if (this.addStrategyType === this.templateType.tempTypeSVoice) {
        this.templateOption = this.templateSVoiceOption;
        this.channelOption = this.svoiceChannelOptions;
      } else {
        this.templateOption = this.templateMsgOption;
        this.channelOption = this.msgChannelOptions;
      }
      this.templateOption.forEach((e, index) => {
        if (e.id === row.templateId) {
          this.addStrategyTemplateIndex = index;
          this.addStrategyTemplateSelected = e;
          return false;
        }
        return true;
      });
      this.labelOption.forEach((e, index) => {
        if (e.id === row.labelId) {
          // 编辑为单选，使用标量索引
          this.addStrategyLabelIndex = index;
          this.addStrategyLabelSelected = [e];
          return false;
        }
        return true;
      });
      if (this.addStrategyLabelSelected[0] && this.addStrategyLabelSelected[0].name === this.labelTypePomiseRepay) {
        this.timeConditionOption = this.timeConditionTwoOption;
      } else {
        this.timeConditionOption = this.timeConditionOneOption;
      }
      this.addStrategyPhone = [];
      if (row.mobileStatus) {
        const mobileStatusList = row.mobileStatus.split(',');
        this.mobileStatusOption.forEach((e) => {
          mobileStatusList.forEach((status) => {
            if (e.modelName === status) {
              this.addStrategyPhone.push(e.modelCode);
            }
          });
        });
      }
      this.addStrategyReplay = row.contactTypeCode;
      this.addStrategySend = row.collectSendObject.split('&');
      this.addStrategyTimeCondition = row.timeConditionType;
      this.addStrategyTimeConditionChange(this.addStrategyTimeCondition);
      this.addStrategyChannel = row.msgChannel;
      this.addStrategyActive = row.enable;
      this.addStrategyLimitCondition = row.limitCondition;
      this.isSend = row.isSend;
      this.isFollow = row.isFollow;
      this.noLimitStrategy = !!row.noLimitStrategy;
      this.addDay = row.days;
      this.addDayChange(this.addDay);
      if (this.addStrategyTimeCondition === this.timeTypePomiseRepay) this.addNoResponseTime = row.noResponseTime / 60;
      else this.addNoResponseTime = row.point / 60;
      this.addStrategyVisible = true;
    },
    addStrategyTypeChange(val) {
      if (val === this.templateType.tempTypeVoice) {
        this.channelOption = this.ivrChannelOptions;
        this.addStrategyTemplateSelected = this.templateVoiceOption[0];
        this.templateOption = this.templateVoiceOption;
      } else if (val === this.templateType.tempTypeMsg) {
        this.channelOption = this.msgChannelOptions;
        this.addStrategyTemplateSelected = this.templateMsgOption[0];
        this.templateOption = this.templateMsgOption;
      } else if (val === this.templateType.tempTypeIVoice) { // 智能语音
        this.channelOption = this.ivoiceChannelOptions;
        this.addStrategyTemplateSelected = this.templateIVoiceOption[0];
        this.templateOption = this.templateIVoiceOption;
      } else if (val === this.templateType.tempTypeSVoice) { // 场景语音
        this.channelOption = this.svoiceChannelOptions;
        this.addStrategyTemplateSelected = this.templateSVoiceOption[0];
        this.templateOption = this.templateSVoiceOption;
      }
      this.addStrategyChannel = null;
    },
    addStrategyLabelChange(val) {
      // 编辑为单选，val 是单个索引；新增为多选，val 为索引数组
      if (this.isEdit) {
        const arr = (val === 0 || val) ? [val] : [];
        this.addStrategyLabelSelected = arr.map(index => this.labelOption[index]);
      } else {
        this.addStrategyLabelSelected = (val || []).map(index => this.labelOption[index]);
      }
      const hasPromiseRepay = this.addStrategyLabelSelected.some(l => l && l.name === this.labelTypePomiseRepay);
      if (hasPromiseRepay) {
        this.addStrategyTimeCondition = this.timeConditionTwoOption[0].value;
        this.timeConditionOption = this.timeConditionTwoOption;
      } else {
        this.addStrategyTimeCondition = this.timeConditionOneOption[0].value;
        this.timeConditionOption = this.timeConditionOneOption;
      }
    },
    addStrategyTimeConditionChange(val) {
      if (val === this.timeTypePomiseRepay) {
        this.addDay = '';
        this.addNoResponseTime = '';
        this.addStrategyTimeVisible = false;
      } else {
        this.addDay = 1;
        this.addNoResponseTime = '';
        this.addStrategyTimeVisible = true;
      }
    },
    updateOrInsertStrategyCancel() {
      this.addStrategyVisible = false;
    },
    updateOrInsertStrategySave() {
      if (!this.checkUpdateOrInsertStrategyParams()) return;
      // 编辑
      if (this.updateStrategyId) {
        const label = (this.addStrategyLabelSelected && this.addStrategyLabelSelected[0]) || null;
        if (!label) {
          this.$message({ type: 'warning', message: '请先选择标签' });
          return;
        }
        this.updateOrInsertStrategy(this.getAddStrategyParams(label)).then(() => {
          this.addStrategyVisible = false;
          this.getSengRuleData(this.pageData.currentPage || 1);
        }).catch(() => {
          this.$message({ type: 'error', message: '保存失败，请稍后重试' });
        });
        return;
      }
      // 新增：二次确认 + 批量保存
      const labels = this.addStrategyLabelSelected || [];
      if (!labels.length) {
        this.$message({ type: 'warning', message: '请先选择标签' });
        return;
      }
      const names = labels.map(l => l && l.name).filter(Boolean);
      const content = `将要保存以下标签的策略：${names.join('、')}（共${names.length}个）。是否继续？`;
      this.$confirm(content, '请确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const reqs = labels.map(label => this.getAddStrategyParams(label));
        const calls = reqs.map(req => this.$ajax({
          url: '/strategy/updateOrInsertStrategy',
          prompt: true,
          method: 'POST',
          data: req
        }));
        return Promise.all(calls).then(() => {
          this.$message({ type: 'success', message: `已成功生成${labels.length}条策略` });
          this.addStrategyVisible = false;
          this.getSengRuleData(this.pageData.currentPage || 1);
        });
      }).catch((err) => {
        if (err === 'cancel' || err === 'close') {
          this.$message({ type: 'info', message: '已取消保存' });
        } else {
          this.$message({ type: 'error', message: '保存失败，请稍后重试' });
        }
      });
    },
    checkUpdateOrInsertStrategyParams() {
      if (!(this.addStrategySend && this.addStrategySend.length > 0)) {
        this.$message({
          message: '发送对象不能为空',
          type: 'warning'
        });
        return false;
      }

      if (this.addNoResponseTime !== 0 && !this.addNoResponseTime) {
        this.$message({
          message: '时间条件的小时数不能为空',
          type: 'warning'
        });
        return false;
      }
      if (this.addStrategyTimeCondition === this.timeTypePomiseRepay) {
        if (this.addNoResponseTime < -168 || this.addNoResponseTime > 168) {
          this.$message({
            message: this.addPromiseTimePlaceholder,
            type: 'warning'
          });
          return false;
        }
      } else if (this.addNoResponseTime < this.minNoResponseTime || this.addNoResponseTime > 24) {
        this.$message({
          message: this.addNoResponseTimePlaceholder,
          type: 'warning'
        });
        return false;
      }
      return true;
    },
    updateOrInsertStrategy(req) {
      return this.$ajax({
        url: '/strategy/updateOrInsertStrategy',
        prompt: true,
        method: 'POST',
        data: req
      });
    },
    getAddStrategyParams(labelItem) {
      this.addStrategyTemplateSelected = this.templateOption[this.addStrategyTemplateIndex];
      const label = labelItem || (this.addStrategyLabelSelected && this.addStrategyLabelSelected[0]) || {};
      const req = {
        'id': this.updateStrategyId,
        'type': this.addStrategyType,
        'templateId': this.addStrategyTemplateSelected.id,
        'templateName': this.addStrategyTemplateSelected.name,
        'labelId': label.id,
        'labelName': label.name,
        'contactTypeCode': this.addStrategyReplay,
        'noResponseTime': this.addNoResponseTime * 60,
        'days': this.addDay,
        'timeConditionType': this.addStrategyTimeCondition,
        'enable': this.addStrategyActive,
        'mobileStatusList': this.addStrategyPhone,
        'collectSendObject': this.addStrategySend.join('&'),
        'companyId': this.companyId,
        'groupId': this.groupId,
        'msgChannel': this.addStrategyChannel,
        'limitCondition': this.addStrategyLimitCondition,
        'isSend': this.isSend,
        'isFollow': this.isFollow,
        'noLimitStrategy': this.noLimitStrategy
      };
      return req;
    },
    addDayChange(val) {
      if (val === 1) this.minNoResponseTime = 0;
      else this.minNoResponseTime = this.strategyPoint;
      this.addNoResponseTimePlaceholder = '小时数值为'.concat(this.minNoResponseTime, '~24');
      this.addNoResponseTime = '';
    },
    handleInput(e) {
      // 通过正则过滤小数点后两位
      e.target.value = (e.target.value.match(/^\d*(\.?\d{0,1})/g)[0]) || null;
    },
    deleteStrategyOper(row) {
      this.$confirm('确定删除该模板?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.openOrCloseStrategyOperReq.id = row.id;
        this.openOrCloseStrategyOperReq.enable = true;
        this.openOrCloseStrategyOperReq.labelId = row.labelId;
        this.$ajax({
          url: '/strategy/deleteStrategy',
          prompt: true,
          method: 'POST',
          data: this.openOrCloseStrategyOperReq
        }).then(() => {
          this.search();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    openOrCloseStrategyOper(row) {
      this.openOrCloseStrategyOperReq.id = row.id;
      this.openOrCloseStrategyOperReq.enable = row.enable;
      this.openOrCloseStrategyOperReq.labelId = row.labelId;
      this.$ajax({
        url: '/strategy/openOrCloseStrategy',
        prompt: true,
        method: 'POST',
        data: this.openOrCloseStrategyOperReq
      }).catch(() => {
        this.search();
      });
    }
  }
};
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/page/main/collection/engine/send_rule.vue